import React from 'react';
import Panel from './Panel';
import Inclusao from '../../components/Panel/Inclusao/Page';




const InclusaoPage = () => {

    return (
        <Panel>
            <div>
                {/* <p className="title_panel_plans">Incluir dependentes</p> */}
                <Inclusao />
            </div>
        </Panel>

    );
};

export default InclusaoPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/InclusaoPage.js
 **/